<template>
  <div>
    <v-switch v-model="showHtml" :label="$t('show_html')" />
    <div v-if="!showHtml">
      <quillEditor
        :value="value"
        :options="editorOptions"
        :name="name"
        :error-messages="errorMessages"
        :label="label"
        class="custom-editor"
        @input="$emit('input', $event)"
      />
      <div class="v-messages error--text">{{ errorMessages[0] }}</div>
    </div>

    <v-textarea
      v-else
      :value="value"
      :name="name"
      :error-messages="errorMessages"
      :label="label"
      class="custom-base-text-editor-textarea"
      auto-grow
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Quill from 'quill';
import { quillEditor } from 'vue-quill-editor';

const Size = Quill.import('attributors/style/size');
Size.whitelist = ['0.75em', false, '1.5em', '2.5em'];
Quill.register(Size, true);

export default {
  name: 'BaseTextEditor',

  components: { quillEditor },

  props: {
    value: { type: String, default: '' },
    errorMessages: { type: Array, default: () => [] },
    label: { type: String, default: '' },
    name: { type: String, default: '' },
    required: { type: Boolean, default: false },
  },

  data() {
    return {
      showHtml: false,
    };
  },

  computed: {
    editorOptions() {
      let placeholderText = this.$t('editor_placeholder_text');
      if (this.required) {
        placeholderText = `${placeholderText}*`;
      }

      return {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ size: Size.whitelist }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ color: [] }, { background: [] }],
            ['link', 'image'],
          ],
        },
        placeholder: placeholderText,
      };
    },
  },
};
</script>

<style>
.custom-base-text-editor-textarea {
  border: 1px solid #ccc;
  padding: 20px 0 0 15px;
  min-height: 250px;
  margin: 0;
  overflow: auto;
  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
  font-size: 13px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='0.75em']::before {
  content: 'Small';
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='0.75em']::before {
  content: 'Small';
  font-size: 11px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='1.5em']::before {
  content: 'Large';
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='1.5em']::before {
  content: 'Large';
  font-size: 19px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='2.5em']::before {
  content: 'Huge';
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='2.5em']::before {
  content: 'Huge';
  font-size: 28px;
}
</style>
